import { Loader2 } from "lucide-react";
import type { Scenario } from "@/lib/powtoon-be/types";
import { withCacheBust } from "@/lib/utils";

export function WaitingForScoreScreen({ scenario }: { scenario: Scenario }) {
  return (
    <div className="relative flex min-h-[100dvh] items-center justify-center bg-accent overflow-hidden">
      {withCacheBust(scenario.thumb_url, scenario.modified) && (
        <img src={withCacheBust(scenario.thumb_url, scenario.modified)} alt="" className="absolute inset-0 h-full w-full object-cover opacity-60" />
      )}
      <div className="absolute inset-0 bg-background/60" />
      <div className="relative flex flex-col items-center gap-4 text-center px-6 max-w-sm">
        <Loader2 className="h-12 w-12 text-foreground animate-spin" />
        <p className="text-lg font-semibold text-foreground">Processing your results</p>
        <p className="text-sm text-muted-foreground">
          Please wait while your answers are being processed.
        </p>
      </div>
    </div>
  );
}